import { onLCP, onCLS, onINP } from "web-vitals";
import { faro } from "@grafana/faro-web-sdk";

export const collectWebVitals = (routePath) => {
  const push = (metric) => {
    faro.api.pushMeasurement(
      {
        type: "web-vital",
        values: {
          value: metric.value,
        },
      },
      {
        context: {
          name: metric.name,
          rating: metric.rating,
          path: routePath,
        },
      }
    );
  };

  onLCP(push);
  onCLS(push);
  onINP(push);
};
